/* === A11Y: closed dialogs are inert (no focusable content under aria-hidden) === */
(function () {
  var IDS = ['cart-drawer', 'mobile-nav', 'quick-buy-modal', 'img-lightbox', 'newsletter-popup', 'size-chart-modal'];
  function sync(el) { if (el.getAttribute('aria-hidden') === 'true') el.setAttribute('inert', ''); else el.removeAttribute('inert'); }
  function init() {
    var mo = new MutationObserver(function (list) { list.forEach(function (m) { sync(m.target); }); });
    IDS.forEach(function (id) { var el = document.getElementById(id); if (el) { sync(el); mo.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] }); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ============================================
   Teminis.lt Shopify Theme - JavaScript
   ============================================ */

'use strict';

/* === GLOBAL MONEY FORMATTER === */
function formatMoney(cents) {
  if (cents === null || cents === undefined) return '';
  const c = Math.round(Number(cents));
  const euros   = (c / 100).toFixed(2);
  const eurosC  = euros.replace('.', ',');
  const noDecim = Math.floor(c / 100).toString();
  const noDecimC = noDecim;
  const fmt = window.moneyFormat || '€{{amount_with_comma_separator}}';
  return fmt
    .replace('{{amount_with_comma_separator}}',           eurosC)
    .replace('{{amount_no_decimals_with_comma_separator}}', noDecimC)
    .replace('{{amount_no_decimals}}',                    noDecim)
    .replace('{{amount}}',                                euros)
    .replace('{{ amount }}',                              euros);
}

/* === CART === */
class Cart {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.closeBtn = document.getElementById('cart-drawer-close');
    this.countEl = document.getElementById('cart-count');
    this.itemsEl = document.getElementById('cart-items');
    this.subtotalEl = document.getElementById('cart-subtotal');
    this.checkoutBtn = document.getElementById('cart-checkout-btn');
    this.emptyEl = document.getElementById('cart-empty');
    this.footerEl = document.getElementById('cart-footer');

    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });

    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });

    document.addEventListener('submit', e => {
      if (e.target.id === 'add-to-cart-form' || e.target.hasAttribute('data-add-to-cart')) {
        this.handleAddToCart(e);
      }
    });

    document.addEventListener('click', e => {
      if (e.target.matches('[data-cart-remove]')) {
        this.removeItem(e.target.dataset.cartRemove, e.target.dataset.variantId);
      }
      if (e.target.matches('[data-cart-qty-change]')) {
        const line = e.target.dataset.line;
        const delta = parseInt(e.target.dataset.delta || '0');
        const input = document.querySelector(`[data-qty-input="${line}"]`);
        if (input) {
          const newQty = Math.max(0, parseInt(input.value) + delta);
          this.changeQuantity(line, newQty);
        }
      }
    });

    document.addEventListener('change', e => {
      if (e.target.matches('[data-qty-input]')) {
        const line = e.target.dataset.qtyInput;
        const qty = parseInt(e.target.value);
        if (!isNaN(qty)) this.changeQuantity(line, qty);
      }
    });
  }

  open() {
    if (this.drawer) {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
    }
    if (this.overlay) this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    this.refresh();
  }

  close() {
    if (this.drawer) {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
    }
    if (this.overlay) this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.renderCart(cart);
    } catch(e) {
      console.error('Cart refresh error:', e);
    }
  }

  async handleAddToCart(e) {
    e.preventDefault();
    const form = e.target;
    const btn = form.querySelector('[data-add-btn]');
    const originalHTML = btn ? btn.innerHTML : '';

    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span style="display:inline-block;width:18px;height:18px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:spin .7s linear infinite"></span>';
    }

    try {
      const formData = new FormData(form);
      const variantId = parseInt(formData.get('id'));
      if (!variantId) throw new Error(window.cartStrings?.error || 'Pasirinkite variantą');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(formData.get('quantity') || '1')
        })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || window.cartStrings?.error || 'Klaida');

      await this.refresh();
      this.open();
      Toast.show((data.product_title || '') + ' ' + (window.cartStrings?.added || 'pridėta į krepšelį!'), 'success');
    } catch(err) {
      Toast.show(err.message || (window.cartStrings?.error || 'Klaida'), 'error');
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }
    }
  }

  async changeQuantity(line, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      const cart = await res.json();
      this.renderCart(cart);
    } catch(e) {
      console.error('Quantity change error:', e);
    }
  }

  async removeItem(line, variantId) {
    await this.changeQuantity(line, 0);
  }

  renderCart(cart) {
    this.updateCount(cart.item_count);
    this.updateFreeShipping(cart.total_price);

    if (!this.itemsEl) return;

    if (cart.item_count === 0) {
      this.itemsEl.innerHTML = '';
      if (this.emptyEl) this.emptyEl.style.display = 'flex';
      if (this.footerEl) this.footerEl.style.display = 'none';
      return;
    }

    if (this.emptyEl) this.emptyEl.style.display = 'none';
    if (this.footerEl) this.footerEl.style.display = 'block';

    this.itemsEl.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item">
        <img
          class="cart-item__img"
          src="${item.image ? item.image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_120x120.$1') : ''}"
          alt="${this.escape(item.product_title)}"
          loading="lazy"
          ${!item.image ? 'style="display:none"' : ''}>
        <div class="cart-item__info">
          <div class="cart-item__title">${this.escape(item.product_title)}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${this.escape(item.variant_title)}</div>` : ''}
          <div class="cart-item__price">${this.formatMoney(item.final_line_price)}</div>
          <div class="cart-item__actions">
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" data-cart-qty-change data-line="${i + 1}" data-delta="-1" aria-label="Decrease">−</button>
              <input class="cart-item__qty-input" type="number" value="${item.quantity}" min="0" data-qty-input="${i + 1}" aria-label="Quantity">
              <button class="cart-item__qty-btn" data-cart-qty-change data-line="${i + 1}" data-delta="1" aria-label="Increase">+</button>
            </div>
            <button class="cart-item__remove" data-cart-remove="${i + 1}" data-variant-id="${item.variant_id}">Remove</button>
          </div>
        </div>
      </div>
    `).join('');

    if (this.subtotalEl) {
      this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    }
  }

  updateFreeShipping(totalPrice) {
    document.querySelectorAll('[data-free-shipping-nudge]').forEach(nudge => {
      const threshold = Number(nudge.dataset.threshold || 10000);
      const text = nudge.querySelector('[data-free-shipping-text]');
      const progress = nudge.querySelector('[data-free-shipping-progress]');
      const remaining = Math.max(0, threshold - totalPrice);
      if (text) {
        text.textContent = remaining > 0
          ? `Iki nemokamo pristatymo liko ${this.formatMoney(remaining)}`
          : 'Jums priklauso nemokamas pristatymas!';
      }
      if (progress) progress.style.width = `${Math.min(100, (totalPrice / threshold) * 100)}%`;
    });
  }

  updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  formatMoney(cents) { return formatMoney(cents); }

  escape(str) {
    const d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }
}

/* === TOAST === */
class Toast {
  static show(message, type = 'success', duration = 3500) {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.innerHTML = `
      <span class="toast__icon">${type === 'success' ? '✓' : '✕'}</span>
      <div>
        <div class="toast__title">${message}</div>
      </div>
    `;

    container.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(8px)';
      toast.style.transition = 'all 0.3s ease';
      setTimeout(() => toast.remove(), 300);
    }, duration);
  }
}

/* === MOBILE MENU === */
class MobileMenu {
  constructor() {
    this.btn = document.getElementById('menu-toggle');
    this.nav = document.getElementById('mobile-nav');
    if (this.btn && this.nav) {
      this.btn.addEventListener('click', () => this.toggle());
    }
  }

  toggle() {
    const isOpen = this.nav.classList.toggle('is-open');
    this.nav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    this.btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

/* === SEARCH === */
class PredictiveSearch {
  constructor() {
    this.input = document.querySelector('[data-search-input]');
    this.results = document.querySelector('[data-search-results]');
    if (!this.input || !this.results) return;
    this.timer = null;
    this.input.addEventListener('input', () => this.onInput());
    this.input.addEventListener('focus', () => { if (this.input.value.length > 1) this.search(this.input.value); });
    document.addEventListener('click', e => {
      if (!this.input.contains(e.target) && !this.results.contains(e.target)) {
        this.results.classList.add('is-hidden');
      }
    });
  }

  onInput() {
    clearTimeout(this.timer);
    const q = this.input.value.trim();
    if (q.length < 2) { this.results.innerHTML = ''; this.results.classList.add('is-hidden'); return; }
    this.timer = setTimeout(() => this.search(q), 300);
  }

  async search(q) {
    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag`);
      const data = await res.json();
      this.render(data.resources.results.products || []);
    } catch(e) {
      console.error('Search error:', e);
    }
  }

  render(products) {
    if (!products.length) { this.results.innerHTML = ''; this.results.classList.add('is-hidden'); return; }
    this.results.innerHTML = products.map(p => `
      <a href="${p.url}" class="predictive-search__item">
        ${p.featured_image ? `<img class="predictive-search__img" src="${p.featured_image.url}" alt="${p.title}" loading="lazy">` : ''}
        <div class="predictive-search__info">
          <div class="predictive-search__title">${p.title}</div>
          <div class="predictive-search__price">${p.price_min ? this.formatMoney(p.price_min * 100) : ''}</div>
        </div>
      </a>
    `).join('');
    this.results.classList.remove('is-hidden');
  }

  formatMoney(cents) { return formatMoney(cents); }
}

/* === PRODUCT GALLERY === */
class ProductGallery {
  constructor() {
    this.mainImg = document.querySelector('[data-gallery-main]');
    this.prevBtn = document.querySelector('[data-gallery-prev]');
    this.nextBtn = document.querySelector('[data-gallery-next]');
    this.currentIndex = 0;
    this.images = JSON.parse(document.getElementById('gallery-images-data')?.textContent || '[]');

    if (!this.mainImg || this.images.length < 2) return;

    this.thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));
    this.thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => this.goTo(parseInt(thumb.dataset.galleryThumb, 10) || 0));
    });

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    // swipe support
    let touchStartX = 0;
    this.mainImg.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    this.mainImg.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) this.goTo(this.currentIndex + (dx < 0 ? 1 : -1));
    });
  }

  goTo(index) {
    const count = this.images.length;
    this.currentIndex = (index + count) % count;
    const img = this.mainImg.matches('img') ? this.mainImg : this.mainImg.querySelector('img');
    if (img) {
      img.src = this.images[this.currentIndex];
      img.srcset = '';
    }
    if (this.thumbs) {
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.currentIndex));
    }
  }
}

/* === VARIANT SELECTOR === */
class VariantSelector {
  constructor() {
    const form = document.querySelector('#add-to-cart-form, [data-add-to-cart]');
    if (!form) return;
    this.form = form;
    this.variantIdInput = form.querySelector('[name="id"]');
    this.priceEl = document.querySelector('[data-product-price]');
    this.comparePriceEl = document.querySelector('[data-product-compare-price]');
    this.addBtn = form.querySelector('[data-add-btn]');
    this.options = document.querySelectorAll('[data-variant-option]');
    this.variantData = JSON.parse(document.getElementById('product-variants-data')?.textContent || '[]');
    this.selected = {};

    this.options.forEach(opt => {
      opt.addEventListener('click', () => this.selectOption(opt));
    });

    if (this.options.length > 0) {
      const initial = this.findInitialVariant();
      if (initial) {
        (initial.options || []).forEach((val, i) => { this.selected[String(i)] = val; });
        this.syncButtons();
      }
      this.updateVariant();
    }
  }

  // Pirmenybė: ?variant= URL parametras, tada formos [name="id"] reikšmė (Shopify pasirinktas variantas)
  findInitialVariant() {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = parseInt(params.get('variant'), 10);
    const fromInput = parseInt(this.variantIdInput?.value, 10);
    const byId = id => this.variantData.find(v => String(v.id) === String(id));
    return (fromUrl && byId(fromUrl)) || (fromInput && byId(fromInput))
      || this.variantData.find(v => v.available) || this.variantData[0] || null;
  }

  syncButtons() {
    document.querySelectorAll('[data-variant-option]').forEach(o => {
      const idx = o.dataset.optionIndex;
      o.classList.toggle('is-active', this.selected[idx] === o.dataset.optionValue);
    });
  }

  selectOption(opt) {
    const idx = opt.dataset.optionIndex;
    this.selected[idx] = opt.dataset.optionValue;
    this.syncButtons();
    this.updateVariant();
  }

  updateVariant() {
    const selectedValues = Object.entries(this.selected).sort(([a],[b]) => a-b).map(([,v]) => v);
    const match = this.variantData.find(v => {
      return v.options.every((opt, i) => opt === selectedValues[i]);
    });

    // Neegzistuojanti kombinacija: niekada nepaliekame seno varianto ID krepšeliui
    if (!match) {
      if (this.variantIdInput) this.variantIdInput.value = '';
      if (this.addBtn) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = window.cartStrings?.unavailable || window.cartStrings?.soldOut || 'Nepasiekiama';
      }
      if (this.comparePriceEl) this.comparePriceEl.style.display = 'none';
      return;
    }

    if (this.variantIdInput) this.variantIdInput.value = match.id;

    if (this.priceEl) {
      this.priceEl.textContent = this.formatMoney(match.price);
    }

    if (this.comparePriceEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        this.comparePriceEl.textContent = this.formatMoney(match.compare_at_price);
        this.comparePriceEl.style.display = '';
      } else {
        this.comparePriceEl.style.display = 'none';
      }
    }

    if (this.addBtn) {
      if (!match.available) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = window.cartStrings?.soldOut || 'Išparduota';
      } else {
        this.addBtn.disabled = false;
        this.addBtn.textContent = this.addBtn.dataset.addText || window.cartStrings?.addToCart || 'Į krepšelį';
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  formatMoney(cents) { return formatMoney(cents); }
}

/* === BACK TO TOP === */
class BackToTop {
  constructor() {
    this.btn = document.getElementById('back-to-top');
    if (!this.btn) return;
    window.addEventListener('scroll', () => {
      this.btn.classList.toggle('is-visible', window.scrollY > 300);
    }, { passive: true });
    this.btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
}

/* === SLIDESHOW === */
class Slideshow {
  constructor(el) {
    this.el = el;
    this.slides = el.querySelectorAll('.slideshow__slide');
    this.dots = el.querySelectorAll('[data-slide-dot]');
    this.prevBtn = el.querySelector('[data-slide-prev]');
    this.nextBtn = el.querySelector('[data-slide-next]');
    this.current = 0;
    this.timer = null;
    this.autoplay = el.dataset.autoplay === 'true';
    this.speed = parseInt(el.dataset.speed || '5') * 1000;
    if (this.slides.length <= 1) return;
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.go(this.current - 1); this.resetTimer(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.go(this.current + 1); this.resetTimer(); });
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.resetTimer(); }));
    let touchStartX = 0;
    el.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { this.go(this.current + (diff > 0 ? 1 : -1)); this.resetTimer(); }
    });
    if (this.autoplay) this.startTimer();
  }
  go(index) {
    const count = this.slides.length;
    this.current = (index + count) % count;
    this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.current));
    this.dots.forEach((d, i) => {
      const active = i === this.current;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  startTimer() { this.timer = setInterval(() => this.go(this.current + 1), this.speed); }
  resetTimer() { if (this.autoplay) { clearInterval(this.timer); this.startTimer(); } }
}

/* === IMAGE LIGHTBOX === */
class ImageLightbox {
  constructor() {
    this.lightbox = document.getElementById('img-lightbox');
    this.img = document.getElementById('img-lightbox-img');
    if (!this.lightbox) return;
    document.addEventListener('click', e => {
      const t = e.target.closest('[data-zoom]');
      if (t) this.open(t.dataset.zoom || t.src, t);
    });
    this.lightbox.addEventListener('click', e => { if (!e.target.closest('.img-lightbox__img')) this.close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
    document.getElementById('img-lightbox-close')?.addEventListener('click', () => this.close());
  }
  open(src, trigger) {
    if (!this.img) return;
    if (trigger) {
      const w = trigger.naturalWidth || trigger.getAttribute('width');
      const h = trigger.naturalHeight || trigger.getAttribute('height');
      if (w && h) {
        this.img.setAttribute('width', w);
        this.img.setAttribute('height', h);
      }
      this.img.alt = trigger.alt || '';
    }
    this.img.src = src;
    this.lightbox.classList.add('is-open');
    this.lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  close() {
    this.lightbox.classList.remove('is-open');
    this.lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

/* === QUICK BUY MODAL === */
class QuickBuy {
  constructor() {
    this.modal = document.getElementById('quick-buy-modal');
    if (!this.modal) return;
    this.content = this.modal.querySelector('.quick-buy-modal__content');
    this.modal.querySelector('.quick-buy-modal__close')?.addEventListener('click', () => this.close());
    this.modal.querySelector('.quick-buy-modal__backdrop')?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-quick-buy]');
      if (btn) this.open(btn.dataset.quickBuy, btn.dataset.productUrl);
    });
  }
  async open(handle, productUrl) {
    this.productUrl = productUrl || `/products/${handle}`;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.content.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:4rem;color:hsl(var(--muted-foreground))">${window.cartStrings?.loading || 'Kraunama...'}</div>`;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error();
      this.render(await res.json());
    } catch {
      this.content.innerHTML = `<div style="grid-column:1/-1;padding:2rem;text-align:center"><p style="margin-bottom:1.5rem;color:hsl(var(--muted-foreground))">${window.cartStrings?.error || 'Klaida'}</p><a href="${this.productUrl}" class="btn btn--primary">${window.cartStrings?.fullDetails || 'Detali peržiūra'}</a></div>`;
    }
  }
  render(product) {
    const v0 = product.variants.find(v => v.available) || product.variants[0];
    const onSale = v0.compare_at_price && v0.compare_at_price > v0.price;
    const productUrl = this.productUrl || `/products/${product.handle}`;
    const images = this.normalizeImages(product);
    const firstImage = images[0];

    const getOptName = o => (typeof o === 'object' && o !== null) ? o.name : o;
    const getOptValues = (o, i) => {
      if (typeof o === 'object' && o !== null && Array.isArray(o.values)) return o.values;
      return [...new Set(product.variants.map(v => v[`option${i + 1}`]).filter(x => x != null))];
    };
    const isDefaultOption = product.options.length === 1 && getOptName(product.options[0]) === 'Title';
    const hasOpts = !isDefaultOption;

    const optsHtml = hasOpts ? product.options.map((opt, i) => {
      const optName = getOptName(opt);
      const values = getOptValues(opt, i);
      return `<div style="margin-bottom:1rem">
        <p class="variant-label">${this.esc(optName)}</p>
        <div class="variant-options">
          ${values.map(val => {
            const avail = product.variants.some(v => v[`option${i+1}`] === val && v.available);
            return `<button type="button" class="variant-option${!avail?' is-unavailable':''}" data-variant-option data-option-index="${i}" data-option-value="${this.esc(val)}">${this.esc(val)}</button>`;
          }).join('')}
        </div>
      </div>`;
    }).join('') : '';

    const thumbsHtml = images.length > 1 ? `
      <button type="button" class="quick-buy-gallery__nav quick-buy-gallery__nav--prev" data-qb-prev aria-label="Ankstesnė nuotrauka">‹</button>
      <button type="button" class="quick-buy-gallery__nav quick-buy-gallery__nav--next" data-qb-next aria-label="Kita nuotrauka">›</button>
      <div class="quick-buy-gallery__thumbs">
        ${images.map((image, i) => `<button type="button" class="quick-buy-gallery__thumb${i === 0 ? ' is-active' : ''}" data-qb-thumb="${i}" aria-label="Nuotrauka ${i + 1}"><img src="${image.thumb}" alt="" loading="lazy"></button>`).join('')}
      </div>` : '';

    this.content.innerHTML = `
      <div class="quick-buy-modal__media" data-qb-gallery>
        <div class="quick-buy-gallery__main">
          ${firstImage ? `<img class="quick-buy-modal__img" src="${firstImage.large}" data-qb-main-img data-zoom="${firstImage.zoom}" alt="${this.esc(product.title)}" loading="lazy">` : '<div class="product-card__no-img" style="height:100%"></div>'}
        </div>
        ${thumbsHtml}
      </div>
      <div class="quick-buy-modal__info">
        <h2 class="quick-buy-modal__title"><a href="${this.esc(productUrl)}" style="color:inherit;text-decoration:none;">${this.esc(product.title)}</a></h2>
        <div class="quick-buy-modal__price" data-qb-price>
          ${onSale
            ? `<span style="color:hsl(var(--primary))">${formatMoney(v0.price)}</span>&nbsp;<s style="font-size:.875rem;color:hsl(var(--muted-foreground))">${formatMoney(v0.compare_at_price)}</s>`
            : formatMoney(v0.price)}
        </div>
        ${this.specsHtml(product)}
        <form action="/cart/add" method="post" data-add-to-cart>
          <input type="hidden" name="id" value="${v0.id}" id="qb-vid">
          ${optsHtml}
          <div class="quick-buy-modal__actions">
            <button type="submit" class="add-to-cart-btn quick-buy-modal__btn quick-buy-modal__btn--add" data-add-btn data-add-text="${window.cartStrings?.addToCart || 'Į krepšelį'}" ${v0.available ? '' : 'disabled'}>${v0.available ? (window.cartStrings?.addToCart || 'Į krepšelį') : 'Išparduota'}</button>
            <a class="btn btn--outline quick-buy-modal__btn quick-buy-modal__btn--details" href="${this.esc(productUrl)}">${window.cartStrings?.fullDetails || 'Detali peržiūra'}</a>
          </div>
        </form>
      </div>`;

    this.bindQuickGallery(images);

    const variantData = product.variants.map(v => ({
      id: v.id, available: v.available, price: v.price, compare_at_price: v.compare_at_price,
      option1: v.option1, option2: v.option2, option3: v.option3
    }));
    const selected = {};
    // Pradinė būsena — pirmo prieinamo varianto opcijos, o ne pirmi mygtukai
    [v0.option1, v0.option2, v0.option3].forEach((val, i) => { if (val != null) selected[i] = val; });
    const priceEl = this.content.querySelector('[data-qb-price]');
    const addBtn = this.content.querySelector('[data-add-btn]');
    const variantInput = this.content.querySelector('#qb-vid');
    const syncButtons = () => {
      this.content.querySelectorAll('[data-variant-option]').forEach(b => {
        b.classList.toggle('is-active', selected[parseInt(b.dataset.optionIndex)] === b.dataset.optionValue);
      });
    };
    const updateVariant = () => {
      const match = variantData.find(v => Object.entries(selected).every(([i, val]) => v[`option${parseInt(i)+1}`] === val));
      if (!match) {
        if (variantInput) variantInput.value = '';
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = window.cartStrings?.unavailable || 'Nepasiekiama';
        }
        return;
      }
      if (variantInput) variantInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? `<span style="color:hsl(var(--primary))">${formatMoney(match.price)}</span>&nbsp;<s style="font-size:.875rem;color:hsl(var(--muted-foreground))">${formatMoney(match.compare_at_price)}</s>`
          : formatMoney(match.price);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.dataset.addText || 'Į krepšelį') : 'Išparduota';
      }
    };

    this.content.querySelectorAll('[data-variant-option]').forEach(btn => {
      const idx = parseInt(btn.dataset.optionIndex);
      btn.addEventListener('click', () => {
        selected[idx] = btn.dataset.optionValue;
        syncButtons();
        updateVariant();
      });
    });
    syncButtons();
    updateVariant();

    const form = this.content.querySelector('#add-to-cart-form, [data-add-to-cart]');
    if (form && window.cartInstance) {
      form.addEventListener('submit', e => { window.cartInstance.handleAddToCart(e); setTimeout(() => this.close(), 600); });
    }
  }

  specsHtml(product) {
    const tpl = document.querySelector(`template[data-product-specs="${CSS.escape(product.handle)}"]`);
    if (tpl && tpl.innerHTML.trim()) return tpl.innerHTML;
    return '';
  }

  normalizeImages(product) {
    const raw = Array.isArray(product.images) ? product.images : [];
    const list = raw.map(img => typeof img === 'string' ? img : (img?.src || img?.url || '')).filter(Boolean);
    const featured = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image?.src || product.featured_image?.url || '');
    if (featured && !list.includes(featured)) list.unshift(featured);
    return [...new Set(list)].map(src => ({
      thumb: this.imageSized(src, '120x120'),
      large: this.imageSized(src, '700x700'),
      zoom: this.imageSized(src, '1400x1400')
    }));
  }

  imageSized(src, size) {
    if (!src) return '';
    return src.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, `_${size}$1$2`);
  }

  bindQuickGallery(images) {
    if (!images.length) return;
    let current = 0;
    const main = this.content.querySelector('[data-qb-main-img]');
    const thumbs = this.content.querySelectorAll('[data-qb-thumb]');
    const go = index => {
      current = (index + images.length) % images.length;
      if (main) {
        main.src = images[current].large;
        main.dataset.zoom = images[current].zoom;
      }
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
    this.content.querySelector('[data-qb-prev]')?.addEventListener('click', () => go(current - 1));
    this.content.querySelector('[data-qb-next]')?.addEventListener('click', () => go(current + 1));
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  esc(str) { const d = document.createElement('div'); d.appendChild(document.createTextNode(str || '')); return d.innerHTML; }
}

/* === NEWSLETTER POPUP === */
class NewsletterPopup {
  constructor() {
    this.popup = document.getElementById('newsletter-popup');
    if (!this.popup) return;
    const until = localStorage.getItem('nl-dismissed');
    if (until && Date.now() < parseInt(until)) return;
    const delay = parseInt(this.popup.dataset.delay || '4000');
    setTimeout(() => this.show(), delay);
    this.popup.querySelector('.newsletter-popup__backdrop')?.addEventListener('click', () => this.dismiss());
    this.popup.querySelector('.newsletter-popup__close')?.addEventListener('click', () => this.dismiss());
    this.popup.querySelector('.newsletter-popup__dismiss')?.addEventListener('click', () => this.dismiss());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.dismiss(); });
    this.popup.querySelector('form')?.addEventListener('submit', e => {
      e.preventDefault();
      this.dismiss(30 * 86400000);
      Toast.show('Thanks for subscribing!', 'success');
    });
  }
  show() { this.popup.classList.add('is-visible'); this.popup.setAttribute('aria-hidden', 'false'); }
  dismiss(dur = 7 * 86400000) {
    this.popup.classList.remove('is-visible');
    this.popup.setAttribute('aria-hidden', 'true');
    localStorage.setItem('nl-dismissed', Date.now() + dur);
  }
}


/* === COLLECTION SMART FILTERS === */
class CollectionFilters {
  constructor() {
    this.root = document.querySelector('[data-collection-filters]');
    this.grid = document.querySelector('[data-products-grid]');
    if (!this.root || !this.grid) return;
    this.empty = this.root.querySelector('[data-filter-empty]');
    this.category = 'all';
    this.extra = 'all';
    this.keywordMap = {
      all: [],
      kostiumai: ['kostium', 'suknel', 'apranga', 'kombinezon', 'chalatas', 'marškin', 'marskin', 'cosplay', 'uniform'],
      aksesuarai: ['aksesuar', 'pried', 'kauk', 'kard', 'lazdel', 'šalm', 'salm', 'sparn', 'ginkl', 'atribut', 'skryb', 'papuoš', 'papuos'],
      perukai: ['peruk', 'barzd', 'ūs', 'us', 'plauk'],
      makiazas: ['makiaž', 'makiaz', 'daž', 'daz', 'krauj', 'žaizd', 'zaizd', 'blizg', 'lateks', 'klij', 'nagai', 'tatuiruot'],
      dekoracijos: ['dekor', 'balion', 'girliand', 'lemp', 'voratinkl', 'moliūg', 'moliug', 'skelet', 'stalo', 'kab', 'švies', 'svies']
    };
    this.extraMap = {
      halloween: ['halloween', 'helovin', 'siaub', 'horror'],
      vaikams: ['vaik', 'child', 'kids', '13-osios'],
      suaugusiems: ['suaug', 'adult', 'moter', 'vyr'],
      personažai: ['persona', 'batman', 'betmen', 'harry', 'dumbledor', 'flinst', 'assassin', 'dragon', 'dc comics', 'space jam', 'bane'],
      siaubo: ['siaub', 'horror', 'helovin', 'halloween', 'zombi', 'vampyr', 'ragan', 'kaukol'],
      'filmai-zaidimai': ['batman', 'betmen', 'harry', 'dumbledor', 'assassin', 'dragon', 'dc comics', 'space jam', 'flinst', 'marvel'],
      gyvunai: ['gyvūn', 'gyvun', 'kat', 'šun', 'sun', 'zuik', 'vilk', 'liūt', 'liut'],
      kaukes: ['kauk', 'mask'],
      ginklai: ['ginkl', 'kard', 'peil', 'lazdel', 'batarang', 'machet'],
      sparnai: ['sparn'],
      'salmai-skrybeles': ['šalm', 'salm', 'skryb', 'kepur'],
      papuosalai: ['papuoš', 'papuos', 'karol', 'žied', 'zied', 'apyrank'],
      ilgi: ['ilg', 'long'],
      trumpi: ['trump', 'short'],
      'barzdos-usai': ['barzd', 'ūs', 'usai', 'ūsai'],
      spalvoti: ['spalv', 'rož', 'roz', 'raud', 'mėlyn', 'melyn', 'žal', 'zal', 'juod', 'blond'],
      'personazu-perukai': ['harry', 'dumbledor', 'persona', 'princ', 'ragan'],
      'veido-dazai': ['veido', 'daž', 'daz', 'paint'],
      'kraujas-zaizdos': ['krauj', 'žaizd', 'zaizd', 'rand', 'scar'],
      blizguciai: ['blizg', 'glitter'],
      'klijai-lateksas': ['klij', 'lateks'],
      nagai: ['nagai', 'nail'],
      balionai: ['balion'],
      'helovino-dekoras': ['helovin', 'halloween', 'moliūg', 'moliug', 'skelet', 'voratinkl', 'kaukol'],
      'stalo-dekoras': ['stalo', 'servet', 'lėkšt', 'lekst', 'puodel'],
      sviesos: ['švies', 'svies', 'lemp', 'led'],
      'lauko-dekoras': ['lauko', 'kiemo', 'kab', 'girliand']
    };
    this.bind();
    this.apply();
  }

  bind() {
    this.root.querySelectorAll('[data-category-filter]').forEach(btn => {
      btn.addEventListener('click', () => {
        this.category = btn.dataset.categoryFilter;
        this.extra = 'all';
        this.root.querySelectorAll('[data-category-filter]').forEach(b => b.classList.toggle('is-active', b === btn));
        this.root.querySelectorAll('[data-filter-group]').forEach(group => {
          const active = group.dataset.filterGroup === this.category || (this.category === 'all' && group.dataset.filterGroup === 'all');
          group.classList.toggle('is-active', active);
          if (active) group.querySelectorAll('[data-extra-filter]').forEach((b, i) => b.classList.toggle('is-active', i === 0));
        });
        this.apply();
      });
    });
    this.root.querySelectorAll('[data-extra-filter]').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-filter-group]');
        if (!group) return;
        group.querySelectorAll('[data-extra-filter]').forEach(b => b.classList.toggle('is-active', b === btn));
        this.extra = btn.dataset.extraFilter;
        this.apply();
      });
    });
  }

  apply() {
    const cards = this.grid.querySelectorAll('[data-product-card]');
    let visible = 0;
    cards.forEach(card => {
      const text = (card.dataset.filterText || '').toLowerCase();
      const catOk = this.matches(text, this.keywordMap[this.category]);
      const extraOk = this.extra === 'all' || this.matches(text, this.extraMap[this.extra]);
      const show = catOk && extraOk;
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (this.empty) this.empty.hidden = visible !== 0;
  }

  matches(text, terms = []) {
    if (!terms || terms.length === 0) return true;
    return terms.some(term => text.includes(term));
  }
}

/* === LOAD MORE === */
class LoadMore {
  constructor() {
    this.btn = document.getElementById('load-more-btn');
    if (!this.btn) return;
    this.grid = document.querySelector('[data-products-grid]');
    this.label = this.btn.textContent.trim();
    this.nextUrl = this.btn.dataset.nextUrl || this.btn.getAttribute('href');
    this.btn.addEventListener('click', (e) => {
      // Progressive enhancement: the element is a real link, so if anything
      // goes wrong the browser still navigates to the next page.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      this.load();
    });
  }
  setBusy(busy) {
    this.btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    this.btn.classList.toggle('is-loading', busy);
    this.btn.textContent = busy ? (window.cartStrings?.loading || 'Loading...') : this.label;
  }
  async load() {
    if (!this.nextUrl || !this.grid) return;
    this.setBusy(true);
    try {
      const doc = new DOMParser().parseFromString(await (await fetch(this.nextUrl)).text(), 'text/html');
      doc.querySelectorAll('[data-products-grid] .product-card').forEach(p => this.grid.appendChild(p));
      const next = doc.getElementById('load-more-btn');
      const nextUrl = next?.dataset.nextUrl || next?.getAttribute('href');
      if (nextUrl) {
        this.nextUrl = nextUrl;
        this.btn.setAttribute('href', nextUrl);
        this.btn.dataset.nextUrl = nextUrl;
        this.setBusy(false);
      } else {
        this.btn.closest('.load-more-wrap').style.display = 'none';
      }
    } catch {
      this.setBusy(false);
    }
  }
}

/* === COLLECTION SORT (keeps existing query parameters) === */
class CollectionSort {
  constructor() {
    document.querySelectorAll('[data-sort-select]').forEach(select => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }
}


/* === RECENTLY VIEWED === */
class RecentlyViewed {
  constructor() {
    try {
      const dataEl = document.getElementById('recently-viewed-data');
      if (dataEl) {
        const data = JSON.parse(dataEl.textContent);
        let list = JSON.parse(localStorage.getItem('rv') || '[]');
        list = list.filter(p => p.handle !== data.handle);
        list.unshift(data);
        localStorage.setItem('rv', JSON.stringify(list.slice(0, 8)));
      }
      const container = document.getElementById('recently-viewed');
      if (!container) return;
      const curHandle = JSON.parse(document.getElementById('recently-viewed-data')?.textContent || '{}').handle;
      const list = JSON.parse(localStorage.getItem('rv') || '[]').filter(p => p.handle !== curHandle);
      if (!list.length) return;
      container.querySelector('.recently-viewed__grid').innerHTML = list.slice(0, 6).map(p => `
        <a href="${p.url}" class="recently-viewed__item">
          ${p.img ? `<img src="${p.img}" alt="" loading="lazy" class="recently-viewed__img">` : ''}
          <p class="recently-viewed__title">${p.title || ''}</p>
          ${p.price ? `<p class="recently-viewed__price">${formatMoney(p.price)}</p>` : ''}
        </a>`).join('');
      container.style.display = 'block';
    } catch {}
  }
}

/* === PRODUCT TABS === */


/* === FILTER DROPDOWNS === */
class FilterDropdowns {
  constructor() {
    document.querySelectorAll('.filter-dropdown__btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const dd = btn.closest('.filter-dropdown');
        const isOpen = dd.classList.contains('is-open');
        document.querySelectorAll('.filter-dropdown.is-open').forEach(d => {
          d.classList.remove('is-open');
          d.querySelector('.filter-dropdown__btn').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          dd.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.filter-dropdown.is-open').forEach(d => {
        d.classList.remove('is-open');
        d.querySelector('.filter-dropdown__btn').setAttribute('aria-expanded', 'false');
      });
    });
  }
}

/* === SCROLL ANIMATIONS === */
class ScrollAnimations {
  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const els = document.querySelectorAll('.animate-on-scroll');
    if (!els.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => observer.observe(el));
  }
}

/* === TERMS CHECK === */
window.cartTermsCheck = function(e) {
  const cb = document.getElementById('cart-terms-checkbox');
  const err = document.getElementById('cart-terms-error');
  if (!cb) return true;
  if (!cb.checked) {
    e.preventDefault();
    if (err) {
      err.style.display = 'block';
      err.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    const label = document.getElementById('cart-terms-label');
    if (label) {
      label.classList.add('cart-terms--shake');
      setTimeout(() => label.classList.remove('cart-terms--shake'), 500);
    }
    return false;
  }
  if (err) err.style.display = 'none';
  return true;
};

/* === COLLECTION DESCRIPTION TOGGLE (visibility only; full text stays in DOM) === */
class CollectionIntro {
  constructor() {
    document.querySelectorAll('[data-collection-intro]').forEach(wrap => this.init(wrap));
  }
  init(wrap) {
    const content = wrap.querySelector('.collection-intro');
    const btn = wrap.querySelector('[data-collection-intro-toggle]');
    if (!content || !btn) return;
    const collapsedHeight = 152;
    if (content.scrollHeight <= collapsedHeight + 24) return;
    wrap.classList.add('has-toggle');
    btn.addEventListener('click', () => {
      const expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? (btn.dataset.less || 'Rodyti mažiau') : (btn.dataset.more || 'Rodyti daugiau');
      if (!expanded) wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }
}

/* === INIT === */
document.addEventListener('DOMContentLoaded', () => {
  window.cartInstance = new Cart();
  new MobileMenu();
  new PredictiveSearch();
  new ProductGallery();
  new VariantSelector();
  new BackToTop();
  new ImageLightbox();
  new QuickBuy();
  new NewsletterPopup();
  new CollectionFilters();
  new FilterDropdowns();
  new LoadMore();
  new CollectionSort();
  new CollectionIntro();

  new RecentlyViewed();
  new ScrollAnimations();
  document.querySelectorAll('[data-slideshow]').forEach(el => new Slideshow(el));
});

